import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const openModal = (modal: string) => setActiveModal(modal);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-brand-teal text-white py-6 px-4 pb-24 md:pb-6" data-id="element-36">
        <div className="max-w-6xl mx-auto" data-id="element-37">
          <div className="flex flex-row justify-center items-center gap-4 sm:gap-6 text-sm flex-wrap" data-id="element-38">
            <button onClick={() => openModal('privacy')} className="hover:text-brand-gold transition-colors" data-id="element-39">
              Política de Privacidad
            </button>
            <span className="text-teal-300" data-id="element-40">|</span>
            <button onClick={() => openModal('terms')} className="hover:text-brand-gold transition-colors" data-id="element-41">
              Términos y Condiciones
            </button>
            <span className="text-teal-300" data-id="element-42">|</span>
            <button onClick={() => openModal('contact')} className="hover:text-brand-gold transition-colors" data-id="element-43">
              Contacto
            </button>
          </div>
          <div className="text-center mt-6 text-xs text-teal-200" data-id="element-44">
            © 2026 DOG-CALM. Todos los derechos reservados.
          </div>
        </div>
      </footer>

      {/* Modal */}
      {activeModal && <div className="fixed inset-0 bg-black/50 z-[100] flex items-center justify-center p-4" onClick={closeModal} data-id="element-45">
          <div className="bg-white rounded-[20px] max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-46">
            <button onClick={closeModal} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600" data-id="element-47">
              <X className="w-6 h-6" data-id="element-48" />
            </button>

            {activeModal === 'privacy' && <div data-id="element-49">
                <h2 className="text-2xl font-bold font-serif text-gray-900 mb-4" data-id="element-50">
                  Política de Privacidad
                </h2>
                <div className="text-gray-700 space-y-4 text-sm" data-id="element-51">
                  <p data-id="element-52">
                    En DOG-CALM, nos comprometemos a proteger su privacidad.
                    Esta política describe cómo recopilamos, usamos y protegemos
                    su información personal.
                  </p>
                  <h3 className="font-bold text-base" data-id="element-53">
                    Información que Recopilamos
                  </h3>
                  <p data-id="element-54">
                    Recopilamos información que usted nos proporciona
                    directamente, como su nombre, correo electrónico y detalles
                    de pago cuando realiza una compra.
                  </p>
                  <h3 className="font-bold text-base" data-id="element-55">Uso de la Información</h3>
                  <p data-id="element-56">
                    Utilizamos su información para procesar pedidos, mejorar
                    nuestros servicios y comunicarnos con usted sobre su compra.
                  </p>
                  <h3 className="font-bold text-base" data-id="element-57">Protección de Datos</h3>
                  <p data-id="element-58">
                    Implementamos medidas de seguridad para proteger su
                    información personal contra acceso no autorizado.
                  </p>
                </div>
              </div>}

            {activeModal === 'terms' && <div data-id="element-59">
                <h2 className="text-2xl font-bold font-serif text-gray-900 mb-4" data-id="element-60">
                  Términos y Condiciones
                </h2>
                <div className="text-gray-700 space-y-4 text-sm" data-id="element-61">
                  <p data-id="element-62">
                    Al acceder y utilizar este sitio web, usted acepta cumplir
                    con estos términos y condiciones.
                  </p>
                  <h3 className="font-bold text-base" data-id="element-63">Uso del Servicio</h3>
                  <p data-id="element-64">
                    El contenido proporcionado es solo para fines educativos.
                    Los resultados pueden variar según la aplicación individual
                    del protocolo.
                  </p>
                  <h3 className="font-bold text-base" data-id="element-65">
                    Garantía de Devolución
                  </h3>
                  <p data-id="element-66">
                    Ofrecemos una garantía de devolución de 14 días. Si no está
                    satisfecho con los resultados después de aplicar el
                    protocolo, le reembolsaremos el 100% de su inversión.
                  </p>
                  <h3 className="font-bold text-base" data-id="element-67">Propiedad Intelectual</h3>
                  <p data-id="element-68">
                    Todo el contenido del programa DOG-CALM está protegido por
                    derechos de autor y no puede ser reproducido sin permiso.
                  </p>
                </div>
              </div>}

            {activeModal === 'contact' && <div data-id="element-69">
                <h2 className="text-2xl font-bold font-serif text-gray-900 mb-4" data-id="element-70">
                  Contacto
                </h2>
                <div className="text-gray-700 space-y-4" data-id="element-71">
                  <p data-id="element-72">
                    ¿Tiene preguntas o necesita ayuda? Estamos aquí para
                    ayudarle.
                  </p>
                  <div className="bg-cloud-grey p-6 rounded-[20px]" data-id="element-73">
                    <h3 className="font-bold text-base mb-2" data-id="element-74">
                      Correo Electrónico
                    </h3>
                    <a href="mailto:electronicecomjj@gmail.com" className="text-brand-teal hover:text-brand-teal-dark font-semibold" data-id="element-75">
                      electronicecomjj@gmail.com
                    </a>
                  </div>
                  <p className="text-sm" data-id="element-76">
                    Respondemos a todos los correos electrónicos dentro de 24-48
                    horas hábiles.
                  </p>
                </div>
              </div>}
          </div>
        </div>}
    </>;
}